import React, { forwardRef } from 'react';

import DatePicker from '../DayPicker';

const TimePicker = forwardRef((props, ref) => {
    return <DatePicker {...props} picker="time" mode={undefined} ref={ref} />;
});

TimePicker.displayName = 'TimePicker';

export default TimePicker;
